__turbopack_context__.v({
  "RelatedProductsList": "VikUZW_RelatedProductsList",
  "RelatedProductsList__Container": "VikUZW_RelatedProductsList__Container",
  "RelatedProductsList__Group": "VikUZW_RelatedProductsList__Group",
  "RelatedProductsList__List": "VikUZW_RelatedProductsList__List",
  "RelatedProductsList__List--Columns": "VikUZW_RelatedProductsList__List--Columns",
  "RelatedProductsList__ListItem": "VikUZW_RelatedProductsList__ListItem",
  "RelatedProductsList__Title": "VikUZW_RelatedProductsList__Title",
});
